var map = {
	"./Coin.png": "8561",
	"./P3-scaled.jpg": "48ac",
	"./Shiba-BG.jpg": "12e1",
	"./addfriend2.png": "37f2",
	"./ai.png": "d24f",
	"./ai3.png": "ee26",
	"./aladin.jpg": "a190",
	"./analysis.png": "8d6f",
	"./angpao.png": "dafc",
	"./avatar.png": "4d41",
	"./bank/baac.jpg": "e45b",
	"./bank/bankokbank.jpg": "029f",
	"./bank/cimb.jpg": "3a74",
	"./bank/ez-casino-payment-bank-citi.png": "639d",
	"./bank/ghbank.jpg": "d1a9",
	"./bank/gsb.jpg": "d79f",
	"./bank/icbc.jpg": "9bed",
	"./bank/kbank.jpg": "25e9",
	"./bank/kiatnakin.jpg": "f79e",
	"./bank/krungsri.jpg": "6827",
	"./bank/ktb.jpg": "ed77",
	"./bank/lh.jpg": "d9be",
	"./bank/scb.jpg": "c6ff",
	"./bank/standard.jpg": "ac03",
	"./bank/tisco.jpg": "3b85",
	"./bank/tmw.png": "709f",
	"./bank/truewallet.jpg": "6466",
	"./bank/ttb.jpg": "2906",
	"./bank/uob.jpg": "5191",
	"./bank/ธนาคารอิสลาม.jpg": "0387",
	"./bank_register/04b668a17c332608e89c778ddea52129.png": "c822",
	"./bank_register/a.png": "1fae",
	"./bank_register/baac.png": "136d",
	"./bank_register/bangkok.png": "c013",
	"./bank_register/bay.png": "4158",
	"./bank_register/cimb.png": "be46",
	"./bank_register/k.png": "9503",
	"./bank_register/kbank.png": "e06a",
	"./bank_register/ktb.png": "bc4c",
	"./bank_register/lh.png": "5be9",
	"./bank_register/scb.png": "8cd1",
	"./bank_register/stand.png": "1b7a",
	"./bank_register/tos.png": "9df3",
	"./bank_register/truewallet.jpg": "5e4f",
	"./bank_register/ttb.png": "3dfc",
	"./bank_register/uob.png": "e91f",
	"./bigwin-first.png": "c93d",
	"./bigwin-last.png": "40a9",
	"./bigwin-text.png": "3901",
	"./bigwin-v2-bg.png": "44db",
	"./bigwin-v2-jackpot-frame.png": "b447",
	"./bigwin-v2-jackpot.webm": "8114",
	"./btn_hover.png": "7dbd",
	"./cashback.png": "1ae9",
	"./casino.png": "ad84",
	"./casino2.png": "1758",
	"./checkin.png": "d7a6",
	"./coin1.png": "c688",
	"./coins.png": "a83f",
	"./common/logo-horizontal-dark-ameba.png": "086a",
	"./common/logo-horizontal-dark-cq9.png": "51e5",
	"./common/logo-horizontal-dark-evo-play.png": "f890",
	"./common/logo-horizontal-dark-goldy.png": "27c5",
	"./common/logo-horizontal-dark-habanero.png": "b61a",
	"./common/logo-horizontal-dark-joker.png": "6ce39",
	"./common/logo-horizontal-dark-kingmaker.png": "b1e0",
	"./common/logo-horizontal-dark-ps.png": "d6fa",
	"./common/logo-horizontal-dark-rich88.png": "ed06",
	"./common/logo-horizontal-dark-sp.png": "9c05",
	"./common/logo-horizontal-dark-wt-ameba.png": "ce2f",
	"./common/logo-horizontal-dark-wt-bbin-slot.png": "ebef",
	"./common/logo-horizontal-dark-wt-cq9.png": "17a7",
	"./common/logo-horizontal-dark-wt-dragoon-soft.png": "2afb",
	"./common/logo-horizontal-dark-wt-evo-play.png": "b120",
	"./common/logo-horizontal-dark-wt-fa-chai.png": "1f8f",
	"./common/logo-horizontal-dark-wt-gioco-plus.png": "125f",
	"./common/logo-horizontal-dark-wt-goldy.png": "af8c",
	"./common/logo-horizontal-dark-wt-habanero.png": "06eb",
	"./common/logo-horizontal-dark-wt-jili.png": "82ae",
	"./common/logo-horizontal-dark-wt-joker.png": "44c4",
	"./common/logo-horizontal-dark-wt-just-play.png": "9519",
	"./common/logo-horizontal-dark-wt-kalamba.png": "e6b6",
	"./common/logo-horizontal-dark-wt-kingmaker.png": "3e0e",
	"./common/logo-horizontal-dark-wt-mg-slot.png": "669a",
	"./common/logo-horizontal-dark-wt-mgp-slot.png": "fd85",
	"./common/logo-horizontal-dark-wt-mpoker.png": "f30e",
	"./common/logo-horizontal-dark-wt-netent-slot.png": "12e6",
	"./common/logo-horizontal-dark-wt-next-spin.png": "ab04",
	"./common/logo-horizontal-dark-wt-only-play.png": "7e34",
	"./common/logo-horizontal-dark-wt-pg-soft.png": "984d",
	"./common/logo-horizontal-dark-wt-play-tech.png": "bde9",
	"./common/logo-horizontal-dark-wt-pragmatic-play.png": "262d",
	"./common/logo-horizontal-dark-wt-ps.png": "5e0e",
	"./common/logo-horizontal-dark-wt-red-tiger.png": "a7a3",
	"./common/logo-horizontal-dark-wt-relax-gaming.png": "b83f",
	"./common/logo-horizontal-dark-wt-rich88.png": "e33d",
	"./common/logo-horizontal-dark-wt-wm-slot.png": "13d5",
	"./common/logo-horizontal-dark-wtm-endorphina.png": "7c69",
	"./common/logo-horizontal-dark-wtm-pg-soft.png": "f9f8",
	"./common/logo-horizontal-dark-wtm-spinix.png": "5e82",
	"./common/logo-horizontal-dark-wtm-ygg-gaming.png": "8b8e",
	"./contact.png": "dfe7",
	"./continue.png": "1da7",
	"./cover-minigame-bg-mobile.jpg": "b22f",
	"./cover-minigame-bg.jpg": "0fdf",
	"./cover-promotion-bg-mobile.jpg": "ce30",
	"./cover-promotion-bg.jpg": "8018",
	"./cover-redeem-bg-mobile.jpg": "79f6",
	"./cover-redeem-bg-mobile.png": "751d",
	"./cover-redeem-bg.jpg": "5a03",
	"./cover-redeem-bg.png": "0ef7",
	"./cover-slot-bg-mobile.jpg": "20c6",
	"./cover-slot-bg.jpg": "c691",
	"./dolla.png": "d91c",
	"./done.png": "9cda",
	"./dooball.png": "2b8e",
	"./e4c5a43354.png": "f248",
	"./ez-slot-category-brand-hover.png": "d563",
	"./ez-slot-category-brand-mobile.png": "be38",
	"./ez-slot-category-brand.png": "3197",
	"./ez-slot-category-casino-hover.png": "f980",
	"./ez-slot-category-casino-mobile.png": "43d3",
	"./ez-slot-category-casino.png": "a10a",
	"./ez-slot-category-fishing-game-hover.png": "74eb",
	"./ez-slot-category-fishing-game-mobile.png": "faac",
	"./ez-slot-category-fishing-game.png": "c185",
	"./ez-slot-category-new-released-hover.png": "283c",
	"./ez-slot-category-new-released-mobile.png": "5da6",
	"./ez-slot-category-new-released.png": "2f7e",
	"./ez-slot-category-popular-mobile.png": "9e1a",
	"./ez-slot-category-skill-game-hover.png": "e64e",
	"./ez-slot-category-skill-game-mobile.png": "c241",
	"./ez-slot-category-skill-game.png": "669a0",
	"./ez-slot-category-sport-hover.png": "f675",
	"./ez-slot-category-sport-mobile.png": "d418",
	"./ez-slot-category-sport.png": "2c62",
	"./ez-slot-default-bg.f8c254a0.png": "9198",
	"./ez-slot-guitar-card.png": "af31",
	"./ez-slot-ic-coin.png": "4450",
	"./ez-slot-ic-contact-line.png": "e88f",
	"./ez-slot-ic-lock-input.png": "4374",
	"./ez-slot-ic-master-key.png": "9a8e",
	"./ez-slot-ic-menu-bonus.png": "d658",
	"./ez-slot-ic-menu-coupon.png": "6b30",
	"./ez-slot-ic-menu-logout.png": "69bc",
	"./ez-slot-ic-menu-promotion.png": "ceab",
	"./ez-slot-ic-menu-provider.png": "2278",
	"./ez-slot-ic-menu-user.png": "8e19",
	"./ez-slot-ic-star-rank-animation.png": "2b6e",
	"./ez-slot-ic-video-example.png": "78ba",
	"./ez-slot-ic_deposit_mobile.png": "d325",
	"./ez-slot-ic_lobby_mobile.png": "7f10",
	"./ez-slot-ic_lobby_mobile_play.png": "3cf2",
	"./ez-slot-ic_login.png": "79da",
	"./ez-slot-ic_phone.png": "709e",
	"./ez-slot-ic_phone.webp": "df56",
	"./ez-slot-ic_register.png": "4ed4",
	"./ez-slot-ic_register.webp": "5657",
	"./ez-slot-ic_withdraw_mobile.png": "0a47",
	"./ez-slot-menu-slot.png": "b04c",
	"./ez-slot-three-candy.png": "18f7",
	"./ez-theme-switcher-bg.f8595565.jpg": "a9bd",
	"./ez-theme-switcher-ic-deposit-bg.b385841e.png": "03f9",
	"./ez-theme-switcher-ic-deposit.png": "71fd",
	"./ez-theme-switcher-ic-event.png": "4abf",
	"./ez-theme-switcher-ic-line.png": "93f6",
	"./ez-theme-switcher-ic-login.png": "5954",
	"./ez-theme-switcher-ic-promotion.png": "91bf",
	"./ez-theme-switcher-ic-register-bg.a4271207 (1).png": "4a18",
	"./ez-theme-switcher-ic-register-bg.a4271207.png": "92e5",
	"./ez-theme-switcher-ic-register.png": "3b87",
	"./ez-theme-switcher-ic-withdraw-bg.7fb2c410.png": "ec3f",
	"./ez-theme-switcher-ic-withdraw.png": "7456",
	"./favorite.png": "694c",
	"./favorite150.png": "c8a9",
	"./fc5d22292336ddc45a74a42690a103a8.png": "0521",
	"./game-console.png": "c322",
	"./gift-box.png": "f204",
	"./gift.png": "f9fd",
	"./gl-logo.png": "bf35",
	"./hackslot/btn-switch.png": "555e",
	"./hackslot/topic01.png": "9d3a",
	"./hackslot/topic02.png": "b0f0",
	"./hackslot/topic03.png": "e8b6",
	"./hackslot/topic04.png": "db74",
	"./hackslot/topic05.png": "a3fd",
	"./hackslot/topic06.png": "81a4",
	"./hackslot/topic07.png": "5b82",
	"./hackslot/topic08.png": "783b",
	"./history.png": "fc94",
	"./home.png": "28ea",
	"./ic-contact-line.png": "b62d",
	"./ic-gift.png": "1e47",
	"./ic-lock-input.png": "7c08",
	"./ic_library_book.png": "8516",
	"./ic_phone.png": "3d75",
	"./ic_register.png": "8853",
	"./ic_register.webp": "0a57",
	"./ic_user_circle.png": "75bc",
	"./icdeposit.png": "4b43",
	"./icon-fb-bttm.jpg": "6d98",
	"./icon-line.svg": "17f68",
	"./icon-play.png": "b426",
	"./icons/favicon.ico": "647d",
	"./icons/icon-google.png": "8bf1",
	"./icwithdraw.png": "514b",
	"./jackpot.png": "6a07",
	"./level/1.png": "76c9",
	"./level/10.png": "8010",
	"./level/11.png": "550f",
	"./level/2.png": "7f27",
	"./level/3.png": "38a5",
	"./level/4.png": "0a38",
	"./level/5.png": "695b",
	"./level/6.png": "b94b",
	"./level/7.png": "c948",
	"./level/8.png": "7d98",
	"./level/9.png": "78cf",
	"./line-glow-blue.png": "14d9",
	"./line.png": "fe82",
	"./logo-shiba888.png": "59a1",
	"./logo.png": "9d64",
	"./logo2.png": "dd88",
	"./logout.png": "735a",
	"./lotto.png": "73b5",
	"./lowres-ft-banklist.png": "9e03",
	"./lowres-ft-provider.png": "6c18",
	"./menu/PP_1-30.png": "fd2e",
	"./menu/card.png": "5051",
	"./menu/card1.png": "114a",
	"./menu/casino.png": "a3a7",
	"./menu/category-brand-hover.png": "5a1d",
	"./menu/category-brand.png": "7088",
	"./menu/category-casino-hover.png": "d0f1",
	"./menu/category-casino.png": "8b92",
	"./menu/category-favorite-hover.png": "4a96",
	"./menu/category-favorite.png": "0c37",
	"./menu/category-fishing-game-hover.png": "a202",
	"./menu/category-fishing-game.png": "5406",
	"./menu/category-new-released-hover.png": "9958",
	"./menu/category-new-released.png": "020e",
	"./menu/category-popular-hover.png": "16f5",
	"./menu/category-popular.png": "3513",
	"./menu/category-skill-game-hover.png": "852a",
	"./menu/category-skill-game-hover1.png": "8a2a",
	"./menu/category-skill-game.png": "f15b",
	"./menu/category-skill-game1.png": "7a99",
	"./menu/category-sport-hover.png": "66b3",
	"./menu/category-sport.png": "7873",
	"./menu/favorite.png": "5d68",
	"./menu/fish.png": "895e",
	"./menu/hot.png": "5303",
	"./menu/new-game.png": "f15c",
	"./menu/slot.png": "9e00",
	"./menu/sport.png": "47c5",
	"./merry.jpg": "eb43",
	"./money.mp3": "8f0b",
	"./natural-paper-texture.jpg": "74e8",
	"./note.png": "0571",
	"./partner.png": "08cb",
	"./pngegg.png": "1eda",
	"./redeem-rewards.png": "7dbb",
	"./research.png": "1970",
	"./scbelement.webp": "7958",
	"./scratch.png": "7305",
	"./shiba-loading.gif": "7a49",
	"./shiba-loading.png": "aa3e",
	"./shiba888-curve-bottom.png": "55a8",
	"./shiba888-curve-top.png": "40c6",
	"./shiba888-ic-coin.png": "1a28",
	"./shiba888-ic-menu-logout.png": "1ccc",
	"./shiba888-ic-menu-promotion.png": "179c",
	"./shiba888-ic-menu-user.png": "5235",
	"./shiba888-ic-mobile-left-1.png": "34bb",
	"./shiba888-ic-mobile-left-2.png": "94e1",
	"./shiba888-ic-mobile-right-1.png": "2dcd",
	"./shiba888-ic-mobile-right-2.png": "33a4",
	"./shiba888-profile-icon-level-02.png": "3877",
	"./spin.png": "9e89",
	"./status-change.png": "8b48",
	"./status-eveywhere.png": "ba0a",
	"./status-promotion.png": "d19f",
	"./status-rank.png": "3f2c",
	"./status-support.png": "5585",
	"./status-wallet.png": "823c",
	"./success.png": "46e6",
	"./surprise.png": "ec60",
	"./treasure.png": "0edd",
	"./waiting.png": "0c5f",
	"./wedo_pict01.png": "bf90",
	"./wedo_pict02.png": "ba9b",
	"./wedo_pict03.png": "053b",
	"./wedo_pict04.png": "2012",
	"./wedo_pict05.png": "3375",
	"./wedo_pict06.png": "3d54",
	"./wheelbackgroundfinal.png": "125d",
	"./wt-n2live-square.png": "1ef2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";